import { BehaviorSubject, Observable, forkJoin, from, fromEvent, merge, of } from 'rxjs';

import { AccessoryFilterType } from '../model/accessoryFilterType';
import { EquipmentType } from '../model/equipmentType';
import { EssayType } from '../model/essayType';
import { FilterAirType } from '../model/filterAirType';
import { GenericClassTranslate } from '../model/genericClass';
import { Injectable } from '@angular/core';
import { InternalEquipmentStatusService } from './internalEquipmentStatus.service';
import { ProtocolStatusService } from './protocolStatus.service';
import { RequestCacheService } from './requestCache.service';
import { map } from 'rxjs/operators';
import { Constants } from '../utils/constants';

@Injectable()
export class OnlineService {

    essayTypes: EssayType[];
    equipmentTypesAir: EquipmentType[];
    roomTypes: GenericClassTranslate[];
    roomSubtypes: GenericClassTranslate[];
    filterAirTypes: FilterAirType[];
    accessoryFilterTypes: AccessoryFilterType[];

    public latestOnline: boolean;

    private onlineSubject = new BehaviorSubject<boolean>(true);
    // eslint-disable-next-line @typescript-eslint/member-ordering
    public online$ = this.onlineSubject.asObservable();

    constructor(
        private protocolStatusService: ProtocolStatusService,
        private internalEquipmentStatusService: InternalEquipmentStatusService,
        private requestCacheService: RequestCacheService

    ) {
        this.online$ = merge(
            of(navigator.onLine),
            fromEvent(window, 'online').pipe(map(() => true)),
            fromEvent(window, 'offline').pipe(map(() => false))
        );
        this.online$.subscribe(res => this.latestOnline = res);
    }

    downloadCacheableData(): Observable<unknown[]> {
        const obs = [];

        obs.push(this.protocolStatusService.findAll());
        obs.push(this.internalEquipmentStatusService.findAll());

        return forkJoin(obs);
    }

    executeActions(callback: () => void): void {
        this.requestCacheService.executeActions(callback);
    }

    countPendingActions(): Observable<number> {
        return from(this.requestCacheService.countPendingActions());
    }

    isExecutionOffline(id: number): boolean {
        let data = this.getOfflineExecutions();
        return data.some(e => e.id === id);
    }

    getOfflineExecutions(): any[] {
        const data = localStorage.getItem(Constants.OFFLINE_EXECUTION_KEY);
        return data ? JSON.parse(data) : [];
    }

    removeOfflineExecution(id: string) {
        const executions = this.getOfflineExecutions().filter(e => e.id !== id);
        localStorage.setItem(Constants.OFFLINE_EXECUTION_KEY, JSON.stringify(executions));
    }

}
